import React from "react";

export default function About() {
  return <h1> Come Back Later! </h1>;
}
